import { render, staticRenderFns } from "./Heatmap.vue?vue&type=template&id=3170a107&"
import script from "./Heatmap.vue?vue&type=script&lang=js&"
export * from "./Heatmap.vue?vue&type=script&lang=js&"
import style0 from "./Heatmap.vue?vue&type=style&index=0&id=3170a107&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports